import { formatDateTime } from "@/shared/utils/dateTimeHelpers";

import type { RailAvailabilityCell, RailSettingState } from "../../types/paymentRails.types";

/** The row that decides the cell in the CURRENT scope (org view falls back to the global row). */
export function scopedState(cell: RailAvailabilityCell, scopeOrgId: string | null): RailSettingState | null {
  if (scopeOrgId) return cell.organization ?? cell.global;
  return cell.global;
}

/** True in org view when the organization holds its own row on this cell. */
export function hasOwnOverride(cell: RailAvailabilityCell, scopeOrgId: string | null): boolean {
  return scopeOrgId !== null && cell.organization !== null;
}

/** App-locale date, not the browser's — the page may render in another language than the OS. */
export function formatSince(since: string, locale: string): string {
  return formatDateTime(since, { locale, includeTime: false }) || since;
}
